import React from "react";
import cx from "classnames";

import { CLASS_PREFIX, buildHeaderRow } from "../utils";
import SelectAllCheckbox from "./SelectAllCheckbox";

const HeaderRow = ({ maxHeaderCount, cells, columns, headerIndex }) => {
  // If there is only one header row, return null and let the table handle
  if (maxHeaderCount <= 1) {
    return cells.map((c, i) =>
      React.cloneElement(c, {
        children:
          columns[i].title === "__checkbox_selection__" ? (
            <SelectAllCheckbox />
          ) : (
            c.props.children
          )
      })
    );
  }

  // If this the last header row, stretch ophan columns
  if (headerIndex === maxHeaderCount - 1) {
    let count = 0;
    return cells.map((c, i) => {
      if (columns[i].parents.length === 0 && maxHeaderCount > 1) {
        const elem = React.cloneElement(c, {
          className: cx(
            c.props.className,
            `${CLASS_PREFIX}__header-cell--orphan`,
            { [`${CLASS_PREFIX}__header-cell--first-orphan`]: count === 0 }
          ),
          children:
            columns[i].title === "__checkbox_selection__" ? (
              <SelectAllCheckbox />
            ) : (
              c.props.children
            )
        });
        count++;
        return elem;
      }
      count = 0;
      return c;
    });
  }

  const groupCells = columns.map(({ parents }, index) => {
    const title = parents[headerIndex] || "__empty-header__";
    return { title, width: cells[index].props.style.width };
  });

  const mergedHeaderCells = buildHeaderRow(groupCells);

  return mergedHeaderCells.map(({ title, width }, index) => (
    <div
      className={`${CLASS_PREFIX}__header-cell--parent`}
      key={`${title}-${index}`}
      style={{ width }}
    >
      {title === "__empty-header__" ? "" : title}
    </div>
  ));
};

export default HeaderRow;
